// removed by extract-text-webpack-plugin
module.exports = {"text800":"_1z834gRDaEGMUovDSwaF_x","text700":"GePlXifOc2JdaJp80UvZO","text600":"_26ixCkj0gUsUoe_Xvv-IAC","text500":"_1jIekJ2_bH-jarqzdaWbos","text400":"_1gE80BdoAQhb-nkeOiGjzp","text300":"Eih9UL6Wz6NzKwP-B54Ey","text200":"_2ktJChyS1jrkFyVO3vPm3M","textParagraph":"_2yPV7GzkNVc3uZYbA59IxZ","crimp":"_36YQW4McA5Evb3wuiLtKk0","trim":"aci6VoO8B254DOeKYQAnm","flexCenter":"_3yW7tLP-mbP5bNj9dg9Y_y","brand":"_1z5VMQEfEm50DR_MZwwpEA","hideTextOverflow":"-y8xoGMtrstxonfnQQySb","marginPageMainContent":"bks_95bvZpKDfoqcEltFe","brandLogo":"pGb2KKMZVMQQotaUZFbk2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/HeaderItemBrandSmall.scss
// module id = 756
// module chunks = 0